import { ReactNode } from 'react'

import { List as MuiList, SxProps } from '@mui/material'

type Props = {
  sx?: SxProps
  children?: ReactNode
}

function List({ sx, children }: Props) {
  return <MuiList sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', ...sx }}>{children}</MuiList>
}

export default List
